import { FormField } from "@babackapp/ui/components/form";
import { Input } from "@babackapp/ui/components/input";
import { useTranslation } from "react-i18next";
import { useWorkflowForm } from "../../context/workflows-editor-workflows-context";
import { useNodeFormPath } from "../../hooks/use-node-form-path";
import { PanelContent } from "../../lib/panel/panel-content";

const BREVO_EVENT_NAME_REGEX = /^[A-Za-z0-9_-]+$/;
const BREVO_EVENT_NAME_MAX_LENGTH = 255;

export function PanelBrevoEvent() {
  const { t } = useTranslation("trackoffice");
  const form = useWorkflowForm();

  const eventNamePath = useNodeFormPath("config.eventName");

  if (!eventNamePath) {
    return null;
  }

  return (
    <PanelContent
      title={t("workflowsEditor.brevoEvent.panelTitle", "Brevo Event")}
    >
      <div className="space-y-4">
        <p className="text-xs text-muted-foreground">
          {t(
            "workflowsEditor.brevoEvent.description",
            "This node sends an event to Brevo with the current workflow data. Use this event in Brevo to trigger automations.",
          )}
        </p>

        <div className="flex flex-col gap-1.5">
          <span className="font-medium text-xs text-muted-foreground">
            {t("workflowsEditor.brevoEvent.eventNameLabel", "Event name")}
          </span>
          <FormField
            control={form.control}
            name={eventNamePath}
            render={({ field }) => {
              const value = (field.value as string | undefined) ?? "";
              const isInvalid =
                value.length > 0 &&
                (value.length > BREVO_EVENT_NAME_MAX_LENGTH ||
                  !BREVO_EVENT_NAME_REGEX.test(value));

              return (
                <>
                  <Input
                    {...field}
                    value={value}
                    aria-invalid={isInvalid}
                    className="text-sm"
                  />
                  {isInvalid && (
                    <span role="alert" className="text-xs text-destructive">
                      {t(
                        "workflowsEditor.brevoEvent.eventNameInvalid",
                        "Only letters, digits, hyphens and underscores are allowed (255 characters max).",
                      )}
                    </span>
                  )}
                </>
              );
            }}
          />
          <span className="text-xs text-muted-foreground">
            {t(
              "workflowsEditor.brevoEvent.eventNameHelp",
              "Name of the event Brevo receives. Only letters, digits, - and _ are allowed.",
            )}
          </span>
        </div>
      </div>
    </PanelContent>
  );
}
